module.exports = __webpack_public_path__ + "img/orange-square-table-4.3d236ad2.png";